
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {Level2} from '../core/Level2';
import {FieldModelLevel2} from '../core/Level2';

/**
 * Level2FilterResponse struct
 */
class Level2FilterResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!Map=} level2
   * @constructor
   */
  constructor (parent = new Response(), level2 = new Map()) {
    super()
    super.copy(parent)
    this.Level2 = level2
  }

  /**
   * Copy struct (shallow copy)
   * @this {!Level2FilterResponse}
   * @param {!Level2FilterResponse} other Other struct
   * @returns {!Level2FilterResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Level2 != null) {
      this.Level2 = new Map()
      Object.keys(other.Level2).forEach(key => {
        if (key != null) {
          let tempKey
          tempKey = key
          if (other.Level2[key] != null) {
            let tempValue
            tempValue = Level2.fromObject(other.Level2[key])
            this.Level2.set(tempKey, tempValue)
          } else {
            this.Level2.set(tempKey, null)
          }
        }
      })
    } else {
      this.Level2 = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!Level2FilterResponse}
   * @returns {!Level2FilterResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new Level2FilterResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new Level2FilterResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!Level2FilterResponse}
   * @param {!Level2FilterResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof Level2FilterResponse)) {
      throw new TypeError('Instance of Level2FilterResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!Level2FilterResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Level2: ((this.Level2 != null) ? fbe.MapToObject(new Map(Array.from(this.Level2, item => [((item[0] != null) ? item[0] : null), ((item[1] != null) ? item[1] : null)]))) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return Level2FilterResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!Level2FilterResponse} other Object value
   * @returns {!Level2FilterResponse} Created struct
   */
  static fromObject (other) {
    return new Level2FilterResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!Level2FilterResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return Level2FilterResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!Level2FilterResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5040
  }
}

export { Level2FilterResponse };

/**
 * Fast Binary Encoding Level2FilterResponse field model
 */
class FieldModelLevel2FilterResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.Level2 = new fbe.FieldModelMap(new fbe.FieldModelString(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), new FieldModelLevel2(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelLevel2FilterResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelLevel2FilterResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelLevel2FilterResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Level2.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelLevel2FilterResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Level2.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelLevel2FilterResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelLevel2FilterResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelLevel2FilterResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5040
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelLevel2FilterResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelLevel2FilterResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Level2.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Level2.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Level2.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelLevel2FilterResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelLevel2FilterResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelLevel2FilterResponse}
   * @param {!Level2FilterResponse} fbeValue Default value, defaults is new Level2FilterResponse()
   * @returns {!Level2FilterResponse} Level2FilterResponse value
   */
  get (fbeValue = new Level2FilterResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelLevel2FilterResponse}
   * @param {!Level2FilterResponse} fbeValue Level2FilterResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Level2.fbeSize) <= fbeStructSize) {
      this.Level2.get(fbeValue.Level2)
    } else {
      fbeValue.Level2.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Level2.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelLevel2FilterResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelLevel2FilterResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelLevel2FilterResponse}
   * @param {!Level2FilterResponse} fbeValue Level2FilterResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelLevel2FilterResponse}
   * @param {Level2FilterResponse} fbeValue Level2FilterResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Level2.set(fbeValue.Level2)
  }
}

export { FieldModelLevel2FilterResponse };

/**
 * Fast Binary Encoding Level2FilterResponse model
 */
class Level2FilterResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelLevel2FilterResponse(this.buffer, 4)
  }

  /**
   * Get the Level2FilterResponse model
   * @this {!Level2FilterResponseModel}
   * @returns {!FieldModelLevel2FilterResponse} model Level2FilterResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!Level2FilterResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!Level2FilterResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return Level2FilterResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!Level2FilterResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelLevel2FilterResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!Level2FilterResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!Level2FilterResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!Level2FilterResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!Level2FilterResponseModel}
   * @param {!Level2FilterResponse} value Level2FilterResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!Level2FilterResponseModel}
   * @param {!Level2FilterResponse} value Level2FilterResponse value, defaults is new Level2FilterResponse()
   * @return {!object} Deserialized Level2FilterResponse value and its size
   */
  deserialize (value = new Level2FilterResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new Level2FilterResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new Level2FilterResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!Level2FilterResponseModel}
   * @param {!number} prev Previous Level2FilterResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { Level2FilterResponseModel };
